import * as L from 'leaflet';

export const OPEN_STREET_MAP_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
export const OPEN_STREET_MAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
export const OPEN_STREET_MAP_REFERRER_POLICY = 'strict-origin-when-cross-origin' as const;

type TileLayerOptionsWithReferrer = L.TileLayerOptions & {
  referrerPolicy?: boolean | ReferrerPolicy;
};

class ReferrerPolicyTileLayer extends L.TileLayer {
  override createTile(coords: L.Coords, done: L.DoneCallback): HTMLElement {
    const tile = super.createTile(coords, done) as HTMLImageElement;
    tile.referrerPolicy = OPEN_STREET_MAP_REFERRER_POLICY;
    return tile;
  }
}

export function createOpenStreetMapTileLayer(options: L.TileLayerOptions = {}): L.TileLayer {
  const mergedOptions: TileLayerOptionsWithReferrer = {
    attribution: OPEN_STREET_MAP_ATTRIBUTION,
    referrerPolicy: OPEN_STREET_MAP_REFERRER_POLICY,
    ...options,
  };

  return new ReferrerPolicyTileLayer(OPEN_STREET_MAP_TILE_URL, mergedOptions);
}
